<div class="privacy-policy-page">
  <!-- Hero Section -->
  <section class="hero-section">
    <div class="hero-content">
      <h1>Privacy Policy</h1>
      <p class="subtitle">Your privacy is important to us. This policy explains how we collect, use, and protect your information.</p>
      <p class="last-updated">Last Updated: {{ lastUpdated }}</p>
    </div>
  </section>

  <!-- Main Content -->
  <div class="content-container">
    <!-- Table of Contents Sidebar -->
    <aside class="toc-sidebar">
      <div class="toc-sticky">
        <h3>Table of Contents</h3>
        <nav class="toc-nav">
          <ul>
            <li *ngFor="let section of sections">
              <a [href]="'#' + section.id" class="toc-link">{{ section.title }}</a>
            </li>
          </ul>
        </nav>
      </div>
    </aside>

    <!-- Policy Content -->
    <main class="policy-content">
      <div class="introduction">
        <p>At HoneyKode, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy describes how we collect, use, disclose, and safeguard your information when you use our technology services and visit our website.</p>
        <p>By using our services, you agree to the collection and use of information in accordance with this policy. If you do not agree with our policies and practices, please do not use our services.</p>
      </div>

      <section *ngFor="let section of sections" [id]="section.id" class="policy-section">
        <h2>{{ section.title }}</h2>
        <div [innerHTML]="section.content"></div>
      </section>

      <!-- Additional Legal Information -->
      <section class="additional-info">
        <h2>Additional Information</h2>
        <div class="info-grid">
          <div class="info-card">
            <h3>GDPR Compliance</h3>
            <p>We comply with the General Data Protection Regulation (GDPR) for users in the European Union, providing transparency and control over your personal data.</p>
          </div>
          <div class="info-card">
            <h3>CCPA Compliance</h3>
            <p>We comply with the California Consumer Privacy Act (CCPA), ensuring California residents have the right to know what personal information is collected and how it's used.</p>
          </div>
          <div class="info-card">
            <h3>Data Protection Officer</h3>
            <p>For privacy-related inquiries, you may contact our Data Protection Officer at <a href="mailto:dpo@honeykode.com">dpo@honeykode.com</a>.</p>
          </div>
          <div class="info-card">
            <h3>Complaints</h3>
            <p>If you're not satisfied with our response to your privacy concerns, you have the right to lodge a complaint with your local data protection authority.</p>
          </div>
        </div>
      </section>

      <!-- Contact Section -->
      <section class="contact-section">
        <div class="contact-box">
          <h2>Questions About This Policy?</h2>
          <p>If you have any questions or concerns about our Privacy Policy, please don't hesitate to reach out:</p>
          <div class="contact-methods">
            <div class="contact-method">
              <i class="icon-email"></i>
              <div>
                <strong>Email</strong>
                <a href="mailto:privacy@honeykode.com">privacy@honeykode.com</a>
              </div>
            </div>
            <div class="contact-method">
              <i class="icon-phone"></i>
              <div>
                <strong>Phone</strong>
                <span>+1 (555) 123-4567</span>
              </div>
            </div>
          </div>
          <a routerLink="/contact" class="btn-primary">Contact Us</a>
        </div>
      </section>
    </main>
  </div>
</div>

<style>
.privacy-policy-page {
  min-height: 100vh;
  background: #f8f9fa;
}

.hero-section {
  background: linear-gradient(135deg, #d946ef 0%, #9333ea 100%);
  color: white;
  padding: 80px 20px 60px;
  text-align: center;
}

.hero-content h1 {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 1rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.subtitle {
  font-size: 1.25rem;
  margin-bottom: 1rem;
  opacity: 0.95;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.last-updated {
  font-size: 0.95rem;
  opacity: 0.85;
  font-style: italic;
}

.content-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 40px 20px;
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 40px;
  align-items: start;
}

.toc-sidebar {
  position: relative;
}

.toc-sticky {
  position: sticky;
  top: 100px;
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.toc-sticky h3 {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 16px;
  color: #1f2937;
}

.toc-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.toc-nav li {
  margin-bottom: 8px;
}

.toc-link {
  color: #6b7280;
  text-decoration: none;
  font-size: 0.95rem;
  display: block;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.2s;
}

.toc-link:hover {
  background: #f3f4f6;
  color: #d946ef;
  transform: translateX(4px);
}

.policy-content {
  background: white;
  border-radius: 12px;
  padding: 48px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.introduction {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #4b5563;
  margin-bottom: 48px;
  padding-bottom: 32px;
  border-bottom: 2px solid #f3f4f6;
}

.policy-section {
  margin-bottom: 48px;
  scroll-margin-top: 100px;
}

.policy-section h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e5e7eb;
}

.policy-section h3 {
  font-size: 1.4rem;
  font-weight: 600;
  color: #374151;
  margin-top: 24px;
  margin-bottom: 16px;
}

.policy-section p {
  line-height: 1.8;
  color: #4b5563;
  margin-bottom: 16px;
}

.policy-section ul {
  margin: 16px 0;
  padding-left: 24px;
}

.policy-section li {
  line-height: 1.8;
  color: #4b5563;
  margin-bottom: 12px;
}

.policy-section a {
  color: #d946ef;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}

.policy-section a:hover {
  color: #9333ea;
  text-decoration: underline;
}

.contact-info {
  background: #f9fafb;
  padding: 24px;
  border-radius: 8px;
  margin-top: 16px;
}

.contact-info p {
  margin-bottom: 8px;
}

.additional-info {
  margin-top: 48px;
  padding-top: 32px;
  border-top: 2px solid #e5e7eb;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  margin-top: 24px;
}

.info-card {
  background: #f9fafb;
  padding: 24px;
  border-radius: 8px;
  border-left: 4px solid #d946ef;
}

.info-card h3 {
  font-size: 1.2rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 12px;
}

.info-card p {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #6b7280;
  margin: 0;
}

.info-card a {
  color: #d946ef;
  text-decoration: none;
  font-weight: 500;
}

.contact-section {
  margin-top: 64px;
  padding-top: 32px;
  border-top: 2px solid #e5e7eb;
}

.contact-box {
  background: linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%);
  padding: 40px;
  border-radius: 12px;
  text-align: center;
}

.contact-box h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 16px;
}

.contact-box > p {
  font-size: 1.1rem;
  color: #6b7280;
  margin-bottom: 32px;
}

.contact-methods {
  display: flex;
  justify-content: center;
  gap: 48px;
  margin-bottom: 32px;
  flex-wrap: wrap;
}

.contact-method {
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: left;
}

.contact-method strong {
  display: block;
  color: #1f2937;
  margin-bottom: 4px;
  font-size: 0.95rem;
}

.contact-method a,
.contact-method span {
  color: #d946ef;
  text-decoration: none;
  font-size: 1.05rem;
}

.btn-primary {
  display: inline-block;
  background: linear-gradient(135deg, #d946ef 0%, #9333ea 100%);
  color: white;
  padding: 14px 32px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  transition: transform 0.2s, box-shadow 0.2s;
  box-shadow: 0 4px 12px rgba(217, 70, 239, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(217, 70, 239, 0.4);
}

@media (max-width: 968px) {
  .content-container {
    grid-template-columns: 1fr;
  }

  .toc-sidebar {
    order: 2;
  }

  .toc-sticky {
    position: static;
  }

  .policy-content {
    order: 1;
    padding: 32px 24px;
  }

  .hero-content h1 {
    font-size: 2.5rem;
  }
}

@media (max-width: 640px) {
  .hero-section {
    padding: 60px 20px 40px;
  }

  .hero-content h1 {
    font-size: 2rem;
  }

  .subtitle {
    font-size: 1.1rem;
  }

  .policy-content {
    padding: 24px 16px;
  }

  .contact-methods {
    flex-direction: column;
    gap: 24px;
  }

  .contact-method {
    justify-content: center;
  }
}
</style>
